module.exports = __webpack_public_path__ + "8f6024f0ebbc1319bb708c466f75a6a7.svg";